import React, { useState } from 'react';
import Alert from '../common/Alert.js';
import Button from '../common/Button.js';
import companyService from '../../services/CompanyService.js';
import { X, AlertTriangle } from 'lucide-react';

const DeleteCompanyModal = ({ company, onClose, onSuccess }) => {
  const [submitting, setSubmitting] = useState(false);
  const [deletePassword, setDeletePassword] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!deletePassword.trim()) {
      Alert.error('Enter the master admin password');
      return;
    }
    try {
      setSubmitting(true);
      await companyService.purgeCompany(company.id, {
        delete_password: deletePassword,
      });
      Alert.success('Company deleted permanently');
      onSuccess();
      onClose();
    } catch (err) {
      Alert.error(err.response?.data?.error || 'Failed to delete company');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[10000] flex items-center justify-center bg-black/50 p-4">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-md">
        <div className="flex items-center justify-between px-5 py-4 border-b border-gray-200">
          <div className="flex items-center gap-2 text-red-600">
            <AlertTriangle className="w-5 h-5" />
            <h2 className="text-lg font-semibold">Delete Company</h2>
          </div>
          <button type="button" onClick={onClose} className="text-gray-400 hover:text-gray-600">
            <X className="w-5 h-5" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-5 space-y-4">
          <p className="text-sm text-gray-700">
            Permanently delete <strong>{company.company_name}</strong> and all of its data
            (users, shipments, subscriptions, vehicles, and the rest). This cannot be undone.
          </p>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Master Admin Password
            </label>
            <input
              type="password"
              value={deletePassword}
              onChange={(e) => setDeletePassword(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-red-500 text-sm"
              placeholder="Master admin password"
              autoComplete="off"
            />
          </div>

          <div className="flex gap-3 pt-2">
            <Button type="button" variant="secondary" className="flex-1" onClick={onClose} disabled={submitting}>
              Cancel
            </Button>
            <Button
              type="submit"
              variant="danger"
              className="flex-1"
              disabled={submitting || !deletePassword.trim()}
            >
              {submitting ? 'Deleting...' : 'Delete Company'}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default DeleteCompanyModal;
